export const SET_SPEED_DATING_MEETINGS = 'SET_SPEED_DATING_MEETINGS';

export const NOTIFICATION_TO_ROOM = 'notification to room';
export const NOTIFICATION = 'notification';



// WEBPACK FOOTER //
// ./src/modules/speedDating/types.js